import { render, staticRenderFns } from "./CVImageUpload.vue?vue&type=template&id=585de9bc&scoped=true&"
import script from "./CVImageUpload.vue?vue&type=script&lang=js&"
export * from "./CVImageUpload.vue?vue&type=script&lang=js&"
import style0 from "./CVImageUpload.vue?vue&type=style&index=0&id=585de9bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585de9bc",
  null
  
)

export default component.exports